import React, { useEffect } from 'react';
import { logger as log } from '@common/logger';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const createCheckoutSession = React.createContext({});
export let createSessionMachine: any;

const MODULE_NAME = 'machines.createCheckoutSession';

export const useSMCreateSession = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  createSessionMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(createSessionMachine);

  return {
    createSessionMachine,
    createSessionState: state,
    createSessionSend: send,
  };
};
